<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      menus: [
        {
          label: "本月利润",
          name: "costing_list",
          auth: "",
        },
        {
          label: "当月收入",
          name: "MonthlyIncome_list",
          auth: "",
        },
        {
          label: "物资成本",
          name: "Consumablescost_list",
          auth: "",
        },
        {
          label: "服务成本",
          name: "Cost_list",
          auth: "",
        },
        {
          label: "销售佣金",
          name: "Commissions_list",
          auth: "",
        },
      ],
      table: {
        mname: "",
        key: "id",
        url: {
          list: "/admin/system/procurementWork/customerList",
        },
        output: false,
      },
      actions: [],
      filters: [
        {
          label: "医院名称",
          KeyEnter: this.search,
          name: "customerId",
          value: "",
          type: "select",
          dropList: [],
        },
        {
          label: "月份",
          KeyEnter: this.search,
          name: "monthNum",
          value: "",
          type: "select",
          dropList: [
            {
              name: "1月",
              value: "1",
            },
            {
              name: "2月",
              value: "2",
            },
            {
              name: "3月",
              value: "3",
            },
            {
              name: "4月",
              value: "4",
            },
            {
              name: "5月",
              value: "5",
            },
            {
              name: "6月",
              value: "6",
            },
            {
              name: "7月",
              value: "7",
            },
            {
              name: "8月",
              value: "8",
            },
            {
              name: "9月",
              value: "9",
            },
            {
              name: "10月",
              value: "10",
            },
            {
              name: "11月",
              value: "11",
            },
            {
              name: "12月",
              value: "12",
            }
          ],
        },
        {
          label: "年份",
          KeyEnter: this.search,
          name: "yearNum",
          value: "",
          type: "datetimeyear",
        },
      ],
      tableCols: [
       {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "日期",
          minWidth: 90,
          align: "center",
          key: "monthTime",
        },
        {
          title: "医院名称",
          minWidth: 240,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.customerName;
            return (
              <p style="color:#3591f1; cursor: pointer;" onClick={() => this.goInfo(row)}>
                {text}
              </p>
            );
          },
        },
        /* {
          title: "耗材信息",
          minWidth: 250,
          key: "sysProcurementDetails",
          render: (h, params) => {
            return (
              <div>
                {params.row.sysProcurementDetails.map((item) => {
                  return (
                    <div>
                      {item.brand ? item.brand + "/" : ""}
                      {item.model}/{item.name}*{item.alertNum}
                      {item.unit}-<span style="color:blue"> {item.unitPrice}</span>元
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "领用日期",
          minWidth: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime ? row.createTime.slice(0, 16) : null;
            return <span>{text}</span>;
          },
        }, */
        {
          title: "价格",
          minWidth: 100,
          align: "center",
          key: "totalMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.totalMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }} >{num}</p>
              </div>
            );
          },
        }
      ],
    };
  },
  created() {
    this.query1 = {};
    this.query = {};
    this.deskChange();
  },
  methods: {
    timeDateChangeYear(val, name) {
      this.query.yearNum = val;
    },
    goInfo(row) {
      $utils.url.push({
        name: "purchaseIndexAdmin",
        query: {
          customerName: row.customerName,
          receiveTime: this.getMonthStartAndEnd(row.monthTime, 1),
          begin: this.getMonthStartAndEnd(row.monthTime, 2).begin,
          end: this.getMonthStartAndEnd(row.monthTime, 2).end,
        }
      });
    },
    getMonthStartAndEnd(dateString, num) {
      const parts = dateString.split("-");
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const monthStart = new Date(Date.UTC(year, month, 1));
      const monthEnd = new Date(Date.UTC(year, month + 1, 0));
      const formattedStart = monthStart.toISOString().split("T")[0];
      const formattedEnd = monthEnd.toISOString().split("T")[0];
      if (num == 1) {
        return `${formattedStart} - ${formattedEnd}`;
      }
      if (num == 2) {
        return {
          begin: formattedStart,
          end: formattedEnd,
        };
      }
    },
    deskChange() {
      let q = {};
      $utils.api.load("/admin/system/customer/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.customerName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "customerId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
  },
};
</script>
